// Publication logos, downloaded from the NewsVoir syndication report and
// re-encoded to webp. Keyed by the outlet's domain with dots as dashes —
// see logoKey() in pressArticles.ts.
import logoAnshikamediaCom from '../../assets/press/anshikamedia-com.webp'
import logoAryanageCom from '../../assets/press/aryanage-com.webp'
import logoAttentionworldsCom from '../../assets/press/attentionworlds-com.webp'
import logoBizdevelopmentnewsCom from '../../assets/press/bizdevelopmentnews-com.webp'
import logoBizwireexpressCom from '../../assets/press/bizwireexpress-com.webp'
import logoBusinesscannerCom from '../../assets/press/businesscanner-com.webp'
import logoBusinessnewschronicleCom from '../../assets/press/businessnewschronicle-com.webp'
import logoBusinessnewsmatrixCom from '../../assets/press/businessnewsmatrix-com.webp'
import logoBusinesspanoramaIn from '../../assets/press/businesspanorama-in.webp'
import logoBuzzalertsIn from '../../assets/press/buzzalerts-in.webp'
import logoCelebvalleyCom from '../../assets/press/celebvalley-com.webp'
import logoCinebuzznewsNet from '../../assets/press/cinebuzznews-net.webp'
import logoDailyhuntIn from '../../assets/press/dailyhunt-in.webp'
import logoEduNewsNet from '../../assets/press/edu-news-net.webp'
import logoEnterprisedigitalnewsCom from '../../assets/press/enterprisedigitalnews-com.webp'
import logoEntrepreneursnewsroomCom from '../../assets/press/entrepreneursnewsroom-com.webp'
import logoGainfocusprCom from '../../assets/press/gainfocuspr-com.webp'
import logoGlobalbiznewsroomCom from '../../assets/press/globalbiznewsroom-com.webp'
import logoHybizTv from '../../assets/press/hybiz-tv.webp'
import logoIgbtvCom from '../../assets/press/igbtv-com.webp'
import logoIndianconventionsIn from '../../assets/press/indianconventions-in.webp'
import logoIndiantelevisionCom from '../../assets/press/indiantelevision-com.webp'
import logoIndiaonlinenewsIn from '../../assets/press/indiaonlinenews-in.webp'
import logoKbdnewsIn from '../../assets/press/kbdnews-in.webp'
import logoLifecarenewsIn from '../../assets/press/lifecarenews-in.webp'
import logoMediaprismcreativeCom from '../../assets/press/mediaprismcreative-com.webp'
import logoMojopatrakarCom from '../../assets/press/mojopatrakar-com.webp'
import logoNationalbiznewsCom from '../../assets/press/nationalbiznews-com.webp'
import logoNationaltimesmediaCom from '../../assets/press/nationaltimesmedia-com.webp'
import logoNewsherbsCom from '../../assets/press/newsherbs-com.webp'
import logoNewsvoirCom from '../../assets/press/newsvoir-com.webp'
import logoOdishatodayCom from '../../assets/press/odishatoday-com.webp'
import logoPeopletalkyCom from '../../assets/press/peopletalky-com.webp'
import logoPulsexpertechCom from '../../assets/press/pulsexpertech-com.webp'
import logoSangribuzzCom from '../../assets/press/sangribuzz-com.webp'
import logoTechandenvironmentCom from '../../assets/press/techandenvironment-com.webp'
import logoThe24newsIn from '../../assets/press/the24news-in.webp'
import logoThebengalIn from '../../assets/press/thebengal-in.webp'
import logoThenationaltvCom from '../../assets/press/thenationaltv-com.webp'
import logoTimesbiteCom from '../../assets/press/timesbite-com.webp'
import logoUtkalsamacharCom from '../../assets/press/utkalsamachar-com.webp'

export const pressLogos: Record<string, string> = {
    'anshikamedia-com': logoAnshikamediaCom,
    'aryanage-com': logoAryanageCom,
    'attentionworlds-com': logoAttentionworldsCom,
    'bizdevelopmentnews-com': logoBizdevelopmentnewsCom,
    'bizwireexpress-com': logoBizwireexpressCom,
    'businesscanner-com': logoBusinesscannerCom,
    'businessnewschronicle-com': logoBusinessnewschronicleCom,
    'businessnewsmatrix-com': logoBusinessnewsmatrixCom,
    'businesspanorama-in': logoBusinesspanoramaIn,
    'buzzalerts-in': logoBuzzalertsIn,
    'celebvalley-com': logoCelebvalleyCom,
    'cinebuzznews-net': logoCinebuzznewsNet,
    'dailyhunt-in': logoDailyhuntIn,
    'edu-news-net': logoEduNewsNet,
    'enterprisedigitalnews-com': logoEnterprisedigitalnewsCom,
    'entrepreneursnewsroom-com': logoEntrepreneursnewsroomCom,
    'gainfocuspr-com': logoGainfocusprCom,
    'globalbiznewsroom-com': logoGlobalbiznewsroomCom,
    'hybiz-tv': logoHybizTv,
    'igbtv-com': logoIgbtvCom,
    'indianconventions-in': logoIndianconventionsIn,
    'indiantelevision-com': logoIndiantelevisionCom,
    'indiaonlinenews-in': logoIndiaonlinenewsIn,
    'kbdnews-in': logoKbdnewsIn,
    'lifecarenews-in': logoLifecarenewsIn,
    'mediaprismcreative-com': logoMediaprismcreativeCom,
    'mojopatrakar-com': logoMojopatrakarCom,
    'nationalbiznews-com': logoNationalbiznewsCom,
    'nationaltimesmedia-com': logoNationaltimesmediaCom,
    'newsherbs-com': logoNewsherbsCom,
    'newsvoir-com': logoNewsvoirCom,
    'odishatoday-com': logoOdishatodayCom,
    'peopletalky-com': logoPeopletalkyCom,
    'pulsexpertech-com': logoPulsexpertechCom,
    'sangribuzz-com': logoSangribuzzCom,
    'techandenvironment-com': logoTechandenvironmentCom,
    'the24news-in': logoThe24newsIn,
    'thebengal-in': logoThebengalIn,
    'thenationaltv-com': logoThenationaltvCom,
    'timesbite-com': logoTimesbiteCom,
    'utkalsamachar-com': logoUtkalsamacharCom,
}
